var exports = {
  "Z": "x1cb7f6e3--bde64e--layout",
};

module.exports = exports;
